// Default lseg_interface backend. Overridable at runtime from the task pane
// (persisted in OfficeRuntime.storage) so one build can target localhost in
// dev and command.eavest.com in production without rebuilding.
//
// NOTE: the interface backend must allow the add-in origin in CORS_ORIGINS
// (https://localhost:3000 in dev, plus the add-in host in prod) — every
// custom-function call is a cross-origin fetch from Excel's webview.
//
// Baked in at build time from the LSEG_BACKEND_URL env var (webpack
// DefinePlugin); falls back to localhost for local dev. The production Docker
// build sets it to https://command.eavest.com. Still overridable per-user
// from the task pane.
export const DEFAULT_BACKEND_URL = process.env.LSEG_BACKEND_URL || "https://localhost:8201";

export const STORAGE_KEYS = {
  backendUrl: "lseg.backendUrl",
  accessToken: "lseg.accessToken",
  refreshToken: "lseg.refreshToken",
  username: "lseg.username",
} as const;
